var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row-fluid"},[_c('div',{staticClass:"widget-box"},[_c('div',{staticClass:"widget-content nopadding"},[_c('keep-alive',[_c('router-view')],1)],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }